import { GSPElementDataType } from './Element/GSPElementDataType';
import { GSPElementObjectType } from './Element/GSPElementObjectType';
import { CefGSPAssociation } from './Element/GSPAssciation';
import { GSPEnumValue } from './Element/GSPEnumValue';
import { MdRefInfo } from './MdRefInfo/MdRefInfo';
import { DynamicPropSetInfo } from './MdRefInfo/DynamicPropSetInfo';
import { EnumIndexType } from './Element/EnumIndexType';
import { ElementDefaultVauleType } from '../../common-model/src/Element/ElementDefaultVauleType';
import { CustomizationInfo } from '../../common-model/src/CustomizationInfo';



/**
 * 字段定义
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 字段定义
 */
export class GspCommonField {

    /**
     * 唯一标志
     */
    public ID: string;

    /**
     * 编号
     */
    public Code: string;

    /**
     * 名称
     */
    public Name: string;

    /**
     * 数据标识
     */
    public LabelID: string;

    /**
     * 字段数据类型(默认string)
     */
    public MDataType: GSPElementDataType = GSPElementDataType.String;
    // private _mDataType: GSPElementDataType;
    // get MDataType() { if (!this._mDataType) { this._mDataType = GSPElementDataType.String } return this._mDataType; }
    // set MDataType(value: any) { if (value) { this._mDataType = value; } }

    /**
     * 默认值
     */
    public DefaultValue: string;
    /**
     * 默认值类型
     */
    public DefaultValueType: ElementDefaultVauleType;
    /**
     * 字段备注
     */
    public Description: string;
    /**
     * 长度
     */
    public Length: number;

    /**
     * 精度
     */
    public Precision: number;

    /**
     * 是否虚拟字段
     */
    public IsVirtual: boolean;

    /**
     * 是否必须
     */
    public IsRequire: boolean;
    /**
     * 是否大数字
     */
    public IsBigNumber: boolean;
    /**
     * 是否是多语字段
     */
    public IsMultiLanguage: boolean;

    /**
     * 是否引用
     */
    IsRef: boolean;

    /**
     * 字段对象类型(默认None)
     */
    public ObjectType: GSPElementObjectType = GSPElementObjectType.None;
    // private _objectType: GSPElementObjectType;
    // get ObjectType() { if (!this._objectType) { this._objectType = GSPElementObjectType.None } return this._objectType; }
    // set ObjectType(value: any) { this._objectType = value; }

    /**
     * 包含的关联列表
     */
    public ChildAssociations: CefGSPAssociation[];
    // private _childAssociations: GSPAssociation[];
    // get ChildAssociations() { if (!this._childAssociations)
    // { this._childAssociations = Array<GSPAssociation>() } return this._childAssociations; }
    // set ChildAssociations(value: GSPAssociation[]) { this._childAssociations = value; }

    /**
     * 包含的关联列表中是否存在关联
     */
    public get HasAssociation(): boolean {
        if (this.ChildAssociations) {
            return this.ChildAssociations.length > 0;
        } else {
            return false;
        }
    }

    /**
     * 包含的枚举列表
     */
    public ContainEnumValues: GSPEnumValue[];
    // private _containEnumValues: GSPEnumValue[];
    // get ContainEnumValues() { if (!this._containEnumValues)
    // { this._containEnumValues = new Array<GSPEnumValue>(); } return this._containEnumValues; }
    // set ContainEnumValues(value: any) { if (value) { this._containEnumValues = value; } }

    /**
     * 是否关联字段
     */
    public IsRefElement: boolean;

    /**
     * 关联字段Id
     */
    public RefElementID: string;

    /**
     * 所属模型Id
     */
    public BelongModelID: string;

    /**
     * 是否启用业务字段
     */
    IsUdt: boolean;

    /**
     * 业务字段包名
     */
    UdtPkgName: string;

    /**
     * 业务字段ID
     */
    UdtID: string;

    /**
     * 业务字段名称
     */
    UdtName: string;

    /**
     * 多数据库列
     */
    ChildElements: GspCommonField[];

    /**
     * 多数据库列映射关系
     */
    MappingRelation: any[];

    /**
     * 是否udt关联带出字段
     */
    IsFromAssoUdt: boolean;

    // /**
    //  * 是否动态属性字段(转调DynamicPropSetInfo.EnableDynamicProp)
    //  */
    // IsDynamicProp: boolean;

    /**
     * 动态属性集合持久化构件
     */
    DynamicPropSetInfo: DynamicPropSetInfo;
    /**
     * 枚举索引类型
     */
    EnumIndexType: EnumIndexType;

    /**
     * 标签
     */
    BeLabel: string[];

    /**
     * 是否去空格
     */
    EnableRtrim: boolean;
    /**
     * 维度信息
     */
    CustomizationInfo: CustomizationInfo;
}
